import axios from "axios";
import {VGSidebar} from "vgsidebar";

class Catalog {
	constructor(url) {
		this.url = url || (location.origin + location.pathname);
		this.form = document.getElementById('catalog-filter-form');
		this.headers = {
			'V-View': true,
		}
		this.resetFilters = false;
		this.changeLocationEnabled = true;

		this.catalogContainer = null;
	}

	withResetFilters(value = true) {
		this.resetFilters = value;
		return this;
	}

	withChangeLocation(value = true) {
		this.changeLocationEnabled = true;
		return this;
	}

	withHeaders(headers) {
		for (let k in headers) {
			this.headers[k] = headers[k];
		}

		return this;
	}

	setCatalogContainer(container) {
		this.catalogContainer = container;
		return this;
	}

	getCatalogContainer() {
		return this.catalogContainer || document.getElementById('catalog-products');
	}

	makeQueryParams() {
		let formData = new FormData(this.form);
		let result = {};

		for (const [key, value] of formData.entries()) {
			if (!value) {
				continue;
			}

			if (typeof result[key] !== 'undefined') {
				result[key] = [result[key]];
				result[key].push(value);
			} else {
				result[key] = value;
			}
		}

		return new URLSearchParams(result).toString();
	}

	setLocation(loc) {
		history.pushState({reload: true}, "", loc);
		return this;
	}

	setFormAction(loc) {
		this.form.action = loc;
		return this;
	}

	load(callback) {
		if (!this.form) {
			return;
		}

		if (this.resetFilters) {
			this.form.querySelectorAll('input:not(.static)')
				.forEach(el => el.remove());
		}

		let url = this.url;
		let q = this.makeQueryParams();
		if (q) {
			url += `?${q}`;
		}

		this.changeLocationEnabled && this.setLocation(url);
		this.setFormAction(this.url);

		let container = this.getCatalogContainer();
		container?.classList.add('basic-loading');
		[...container.parentElement.querySelectorAll('.catalog-products.scroll-loaded')]
			.forEach(el => el.remove());

		axios.get(url, {
			headers: this.headers
		}).then((response) => {
			let configUpdate = [
				{
					viewName: 'view', element: container,
				},
				{
					viewName: 'view_controls',
					element: document.querySelector('.catalog-controls'),
					callback: () => {
						[...document.querySelectorAll('.catalog-controls [data-vg-toggle="sidebar"]')].forEach((el => {
							VGSidebar.makeInit(el);
						}));
					}
				},
				{
					viewName: 'view_header', element: document.querySelector('.catalog-header'),
				},
				{
					viewName: 'view_breadcrumbs', element: document.querySelector('section.breadcrumbs'),
				},
				{
					viewName: 'view_filters', element: document.getElementById('catalog-filters')
				},
				{
					viewName: 'view_sidebar_sorts', element: document.getElementById('sidebar-sorts')
				}
			];

			for (let config of configUpdate) {
				if (typeof response.data[config.viewName] !== 'undefined' && config.element) {
					config.element.insertAdjacentHTML('beforebegin', response.data[config.viewName]);
					config.element.remove();

					if (config.callback) {
						config.callback(config.element);
					}
				}
			}

			if (response.data.page_h1) {
				let h1 = document.querySelector('.catalog-header h1');
				if (h1) h1.innerHTML = response.data.page_h1;
			}

			if (response.data.page_title) {
				let title = document.querySelector('head title');
				if (title) title.innerText = response.data.page_title;
			}

			if (typeof callback === 'function') {
				callback(response.data);
			}
		});
	}

	loadScrollProducts(container, link) {
		return new Promise((resolve, reject) => {
			axios.get(link, {
				headers: {
					'V-View': true,
					'V-View-Products': true,
				},
			}).then((response) => {
				container.insertAdjacentHTML('afterend', response.data.view);
				let insertedContainer = [...container.parentElement.querySelectorAll('.catalog-products')].pop();
				insertedContainer.classList.add('scroll-loaded');
				insertedContainer.dataset.withChangeLocation = container.dataset.withChangeLocation;

				resolve({
					data: response.data,
					container: insertedContainer
				});
			});
		});
	}
}

export default Catalog;
